import { render, staticRenderFns } from "./headerCom.vue?vue&type=template&id=2d0e9c59&scoped=true&"
import script from "./headerCom.vue?vue&type=script&lang=js&"
export * from "./headerCom.vue?vue&type=script&lang=js&"
import style0 from "./headerCom.vue?vue&type=style&index=0&id=2d0e9c59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e9c59",
  null
  
)

export default component.exports